import { render, staticRenderFns } from "./LinkSharing.vue?vue&type=template&id=c2099acc"
import script from "./LinkSharing.vue?vue&type=script&lang=js"
export * from "./LinkSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports